export const FILE_UPLOAD = {
  MAX_FILE_SIZE: "10 MB",
  SUPPORTED_FILE_TYPES: ["XLS", "XLSX", "CSV"],
  CIP_BULK_UPLOAD_TEMPLATE: "CIP_bulk_upload_template.xlsx",
};

export const CustomModalButtons = {
  CLOSE_BTN: "CLOSE_BTN",
  CANCEL: "CANCEL",
  CONFIRM: "CONFIRM",
};

export const STORAGE_KEYS = {
  CIP_NEVER_SHOW_AGAIN: "CIPneverShowAgain",
};

export const CIP_VALUES = {
  USER: "user",
  BULK: "bulk",
};

export const ADD_CIP_MENU_IDS = {
  ADD_CIP: "add-cip",
  ADD_BULK: "add-bulk",
};

export const FILE_UPLOAD_STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
};

export const FLOW_UNITS = {
  CUBIC_METER_PER_HOUR: "m³/h",
  CUBIC_METER_PER_DAY: "m³/d",
  GPM: "gpm",
};

export const VOLUME_UNITS = {
  CUBIC_METER: "m³",
  KGAL: "kgal",
};

export const FLUX_UNITS = {
  LMH: "lmh",
  GFD: "gfd",
};

export const FLOW_VOLUME_FLUX_MAPPING = {
  [FLOW_UNITS.CUBIC_METER_PER_HOUR]: {
    volume: VOLUME_UNITS.CUBIC_METER,
    flux: FLUX_UNITS.LMH,
  },
  [FLOW_UNITS.CUBIC_METER_PER_DAY]: {
    volume: VOLUME_UNITS.CUBIC_METER,
    flux: FLUX_UNITS.LMH,
  },
  [FLOW_UNITS.GPM]: {
    volume: VOLUME_UNITS.KGAL,
    flux: FLUX_UNITS.GFD,
  },
};